const QuoteAssigneeBadge = ({ user }) => {
  const names = [user?.name, user?.lastName].map((name) => name?.trim()).filter(Boolean);
  const fullName = names.join(" ");
  const initials = names.map((name) => Array.from(name)[0]).join("").toUpperCase();

  return (
    <span
      className="badge rounded-pill ms-2"
      style={{ backgroundColor: "#e8eef6", color: "#1e4881", verticalAlign: "middle" }}
      title={fullName || "Unassigned"}
      aria-label={fullName ? `Assigned to ${fullName}` : "Unassigned"}
    >
      {initials || "?"}
    </span>
  );
};

export default QuoteAssigneeBadge;
